module.exports = __webpack_public_path__ + "static/banner-93dc46e701540616c8c33c1bd0b172e0.png";